const extractRoles = (roles: string[]) => useUniq(
    useFlatMap(roles, role =>
        useMap(role.match(/id=([^,]+)/g) || [], match => match.replace("id=", ""))
    )
)

export const userIsAdmin = (roles: string[]) => {
    if (!isArray(roles)) return false
    return roles.some(role => role.includes("id=Admin") && role.includes("id=MyEfficiency"))
}
